import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface InactiveBadgeProps {
  className?: string;
}

export function InactiveBadge(props: InactiveBadgeProps) {
  const { className } = props;
  const { t } = useTranslation();
  return <span className={classNames('text-gray-500 inline-block', className)}>({t('inactive')})</span>;
}
